<template>
  <div class="regist-birthdate">
    <span class="regist-message">{{headerWord}}</span>
    <form :action="registBirthDateAction" method="post" ref="regbirth">
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" name="birth_date" :value="formatedBirthdate">
      <input type="hidden" name="save" value="1" v-if="isSave">
      <form-birthday name="birthday" @change="onBirthdayChange"/>
      <span class="regbirth-err" v-if="regBirthErr.length > 0">{{regBirthErr}}</span>
    </form>
    <span class="btn-submit" :class="{disabled: !regBirthValid}" @click="onRegBirthSubmitClick">{{regBtnFace}}</span>
  </div>
</template>

<script>
export default {
  name: 'RegistBirthdate',
  props: {
    headerWord: {
      type: String,
      default: '生年月日が登録されていません'
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    isSave: {
      type: Boolean,
      default: false,
    },
    regBtnFace: {
      type: String,
      default: '登録する'
    }
  },
  data(){
    return {
      regBirthValid: false,
      regBirthErr: '',
      regBirthInit: false,
      regBirthVal: null,
    }
  },
  computed: {
    registBirthDateAction(){
      return location.href
    },
    formatedBirthdate(){
      return !!this.regBirthVal ? this.regBirthVal.format('YYYY-MM-DD') : ''
    },
  },
  methods: {
    onBirthdayChange(val){
      if(!this.regBirthInit){
        this.regBirthInit = true
      }else {
        if (val.length === 8) {
          const y = val.substring(0, 4)
          const m = val.substring(4, 6)
          const d = val.substring(6, 8)

          const now = new moment()
          const mom = new moment([+y,+m-1,+d])

          if (mom.isBetween('1940-01-01', now, null, '[)') && mom.isValid()){
            this.regBirthErr = ''
            this.regBirthVal = mom
            this.regBirthValid = true
          }else{
            this.regBirthErr = '正しい日付を入力してください'
            this.regBirthValid = false
            this.regBirthVal = null
          }
        } else {
          this.regBirthErr = ''
          this.regBirthValid = false
          this.regBirthVal = null

        }
      }
    },
    onRegBirthSubmitClick(){
      this.$refs.regbirth.submit()
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

.regist-birthdate {
  padding: 24px 24px 32px;
  background: var(--mess-bg);
  border-radius: 10px;
  .regist-message {
    font-size: 16px;
    font-weight: bold;
    color: var(--key-color);
    margin-bottom: 16px;
    display: block;
    width: 100%;
    text-align: center;
  }
  /deep/ {
    .calenderForm {
      width: 200px;
      margin: 0 auto 32px;
      background: white;
      @include mq('w580'){
        width: 240px;
      }
    }
    .formGroup {
      margin-bottom: 8px;
      height: 44px;
    }
  }
  .regbirth-err {
    color: red;
    display: block;
    width: 100%;
    text-align: center;
  }
  .btn-submit {
    width: 240px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: white;
    background: var(--key-color);
    border-radius: 40px;
    margin: 24px auto 0;
    cursor: pointer;
    &.disabled {
      background: #e0e0e0;
      pointer-events: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/RegistBirthdate.vue